module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-3.e6885c4c.webp";